<template>
  <v-container fluid class="down-top-padding">
    <div id="certificatesPage" class="page">
      <div class="page__header">
        <Toolbar
          :showFiltersPanel="showFiltersPanel"
          @showFiltersPanelChanged="handleShowFiltersPanelChanged"
          @toggleDialog="toggleDialog"
        />
      </div>
      <div class="page__body pa-4">
        <div class="mb-4" v-show="showFiltersPanel">
          <v-row class="my-0">
            <v-col>
              <Filters @filtersChanged="handleFiltersChanged" />
            </v-col>
          </v-row>
        </div>

        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
          <Form
            v-if="dialog"
            @formSubmit="handleFormSubmit"
            :toggleDialog="toggleDialog"
            :isSubmittingForm="isSubmittingForm"
            :selectedCertificate="selectedCertificate"            
          />
        </v-dialog>
        <List
          :page="page"
          :items="items"
          :totalCount="totalCount"
          :isFetchingItems="isFetchingItems"
          :itemsPerPage="itemsPerPage"
          @editItem="handleEditItem"
          @deleteItem="handleDeleteItem"
          @downloadItem="handleDownloadItem"
          @changeStatus="handleChangeStatus"
          @optionsChanged="handleOptionsChanged"
        />
      </div>
      <ConfirmationPopup
        id="certificate-delete-modal"
        v-if="certificateToDelete"
        title="Sertifikatın silinməsi"
        :dialog="confirmationDialog"
        :loading="isDeletingCertificate"
        @confirm="handleDeleteConfirmation"
        @cancel="handleDeleteCancellation"
      >
        <span class="font-weight-bold">
          {{ certificateToDelete.certificateNumber }}
        </span>
        sertifikatı silmək istədiyinizə əminsiniz?
      </ConfirmationPopup>
    </div>
  </v-container>
</template>

<script>
import API from "@/services";
import ConfirmationPopup from "@/shared/Common/ConfirmationPopup.vue";
import bus from "../../../event-bus";
import List from "./components/List/index.vue";
import Form from "./components/Form/index.vue";
import Toolbar from "./components/Toolbar/index.vue";
import Filters from "./components/Toolbar/components/Filters.vue";
import fileDownload from "js-file-download";

export default {
  components: {
    List,
    Form,
    Toolbar,
    ConfirmationPopup,
    Filters,
  },
  data() {
    return {
      dialog: false,
      confirmationDialog: false,
      selectedCertificate: null,
      certificateToDelete: null,
      page: 1,
      isFetchingItems: false,
      isSubmittingForm: false,
      isDeletingCertificate: false,
      totalCount: 0,
      itemsPerPage: 10,
      items: [],
      certificateTypes: [],
      filters: {},
      sortedBy: null,
      sortedDesc: null,
      showFiltersPanel: false,
    };
  },
  async created() {
    this.fetchCertificates();    
  },
  methods: {
    fetchCertificates() {
      this.isFetchingItems = true;
      API.fetchCertificates({
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        sortedBy: this.sortedBy,
        sortedDesc: this.sortedDesc,
        ...this.filters,
      })
        .then((response) => {
          this.items = response.items;
          this.totalCount = response.totalCount;
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Serifikatların siyahısını əldə etmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isFetchingItems = false;
        });
    },
    handleDownloadItem(item) {
       API.downloadCertificate(item.id)
        .then((response) => {
          if (response)
            fileDownload(
              response,
              `Sertifikat ${item.id}.pdf`
            );
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Hesabı əldə etmək mümkün olmadı.",
          });
        })
        .finally(() => {});
    },
    handleFormSubmit(formData) {
      this.isSubmittingForm = true;
      const request = this.selectedCertificate
        ? API.updateCertificate(this.selectedCertificate.id, formData)
        : API.insertCertificate(formData);

      request
        .then(() => {
          this.toggleDialog();
          this.fetchCertificates();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Əməliyyatı aparmaq mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isSubmittingForm = false;
        });
    },
    handleEditItem(item) {
      this.isFetchingItems = true;
      API.fetchCertificateById(item.id)
        .then((response) => {
          this.selectedCertificate = response;
          this.dialog = true;
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Məlumatı əldə etmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isFetchingItems = false;
        });
    },
    handleDeleteItem(item) {
      this.certificateToDelete = item;
      this.confirmationDialog = true;
    },
    handleDeleteConfirmation() {
      this.isDeletingCertificate = true;
      API.deleteCertificate(this.certificateToDelete.id)
        .then(() => {
          this.confirmationDialog = false;
          this.certificateToDelete = null;
          this.fetchCertificates();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Sertifikatı silmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isDeletingCertificate = false;
        });
    },
    handleDeleteCancellation() {
      this.confirmationDialog = false;
      this.certificateToDelete = null;
    },
    handleFiltersChanged(filters) {
      if (JSON.stringify(filters) !== JSON.stringify(this.filters)) {
        this.page = 1;
        this.filters = { ...filters };
        this.fetchCertificates();
      }
    },
    handleChangeStatus(item) {
      this.isFetchingItems = true;

      API.changeCertificateStatus(item.id)
        .then(() => {
          this.fetchCertificates();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Sertifikatın statusunu dəyişmək mümkün olmadı.",
          });
        });
    },
    toggleDialog() {
      this.dialog = !this.dialog;
      if (!this.dialog) {
        this.selectedCertificate = null;
      }
    },
    handleOptionsChanged(item) {
      if (
        this.sortedBy !== item.sortedBy ||
        this.sortedDesc !== item.sortedDesc ||
        this.page !== item.page ||
        this.itemsPerPage !== item.itemsPerPage
      ) {
        this.page = item.page;
        this.itemsPerPage = item.itemsPerPage;
        this.sortedBy = item.sortedBy;
        this.sortedDesc = item.sortedDesc;
        this.fetchCertificates();
      }
    },
    handleShowFiltersPanelChanged(item) {
      this.showFiltersPanel = item;
    },
  },
  
};
</script>
